import { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { postStatusAttachments } from "../../../../../../../MyApi/sb/employes";

import icons from "../../../../../../../Data/icons";
import StatusOptions from "../statusoptions";

import classes from "./attachModal.module.css";


const EmployeAttachmentsModal = ({
  closeModal,
  selectedRowId,
  employesAttachments,
  refetch,
}) => {
  const [image, setImage] =useState("")
  const mutation = useMutation(
    "poststatusattachments",
    (postData) => postStatusAttachments(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
        refetch();
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const statuses = ["pending", "active", "refused", "expired"];
  const selectdData = employesAttachments.find(
    (attach) => attach.id === selectedRowId
  );
  const filename = selectdData.name;
  const status = selectdData.status;

  const CloseBtn = icons.close;
  const DownlodaIcon = icons.Save;

  const getFileExtension = (filename) => {
    return filename.split(".").pop();
  };
  const extension = getFileExtension(filename);
 

  const getFileNameFromUrl = (url) => {
    const urlObj = new URL(url);
    return urlObj.pathname.split("/").pop();
  };

  const fileNameUrl = getFileNameFromUrl(filename);

  const handelPostChangeStatus = (e) => {
    const { value } = e.target;
    mutation.mutate({
      id: selectedRowId,
      status: value,
    });
  };
 
  return (
    <div className={classes.modalOverLay}>
      <div className={classes.modalCard}>
        <div className={classes.modalHeader}>
          <h5 className={classes.modalTitle}></h5>
          <button className={classes.modalCloseBtn} onClick={closeModal}>
            <CloseBtn />
          </button>
        </div>
        <div className={classes.modalBody}>
          {extension === "pdf" ? (
            <iframe src={filename}></iframe>
          ) : (
            <img src={filename} className="img-fluid" />
          )}
        </div>

        <div className={classes.modalFooter}>
          <a href={filename} download={fileNameUrl} target="_blank">
            <button className="btn btn-primary">
              <DownlodaIcon />
            </button>
          </a>
          <select className="form-select" onChange={handelPostChangeStatus}>
            {statuses.map((stat, i) => (
              <StatusOptions key={i} stat={stat} status={status} i={i} />
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EmployeAttachmentsModal;
